import store from '../store.js'
import axios from 'axios'
import { SET_ENUMS, API_URL } from '../constants'

// Main method for translating texts
export const translation = (textKey, params, comment) => {
  let space = ' '
  let intVal = parseInt(textKey)
  if (isNaN(intVal)) return textKey

  var state = store.getState().i18nState
  let langMessages = state.translations[state.lang]

  if (langMessages === undefined) {
    return space
  }

  let message = langMessages[textKey]
  if (message === undefined || message === '') {
    return space
  }

  if (params !== undefined) {
    for (let k in params) {
      let reg = new RegExp('{' + k + '}', 'g')
      message = message.replace(reg, params[k])
    }
  }

  return message
}

// Gets dictionary-key for enum. Optionally updating the enums data from API if enum could not be found.
export const enumtranslate = (key, numb, getIfMissing = true) => {
  let enums = store.getState().common.enums_new

  if (typeof enums[key] !== 'undefined') {
    return enums[key][numb]
  }
  if (getIfMissing === true) { // If enum is missing, try to reload from API
    if (window.isGettingEnums !== true) {
      window.isGettingEnums = true
      console.log('Missing enum for key ', key, 'number', numb, '. Reloading enums...')
      let url = API_URL + '/Enums/Get'
      axios.get(url).then((res) => {
        store.dispatch({
          type: SET_ENUMS,
          enums: res.data
        })
        console.log('Got enums', res)
        window.isGettingEnums = false
      }, (err) => {
        console.error('Error getting enums', err)
        window.isGettingEnums = false
      })
    }
  }
  return numb
}

// Gets a string with the types the orderNote is shared with
export const getOrderNoteShareString = noteShareType => {
  let result = ''

  if (noteShareType === '') throw new Error('empty')
  if (isNaN(noteShareType)) throw new Error('not a number')
  noteShareType = Number(noteShareType)

  // internal
  if ((noteShareType & 1) === 1) {
    result += `${translation(341)}, `
  }

  // customer
  if ((noteShareType & 2) === 2) {
    result += `${translation(17859)}, `
  }

  // paintshop
  if ((noteShareType & 4) === 4) {
    result += `${translation(17860)}, `
  }

  // paint WP
  if ((noteShareType & 8) === 8) {
    result += `${translation(1878)}, `
  }

  return result.replace(/,\s+$/g, '')
}

// Copies the provided text to the clipboard
export const copyTextToClipboard = (text) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text)
  } else {
    var textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.top = '0'
    textArea.style.left = '0'
    textArea.style.position = 'fixed'
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    document.execCommand('copy')
    document.body.removeChild(textArea)
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/helpers.js